"use client";

import { useMemo } from "react";
import { trpc } from "@/lib/trpc/client";
import { createMentionSuggestion } from "@/components/editor/create-mention-suggestion";
import type { MentionSuggestionConfig } from "editor";

/**
 * Returns a stable MentionSuggestionConfig for useRichEditor.
 * Memoized so the editor extension isn't re-created on every render.
 *
 * Uses trpc.useUtils().fetch() — imperative, non-reactive — because
 * the suggestion callback fires inside Tiptap, not during React render.
 */
export function useMentionSuggestion(): MentionSuggestionConfig {
  const utils = trpc.useUtils();

  return useMemo(
    () =>
      createMentionSuggestion(async (query) => {
        const result = await utils.members.searchForMention.fetch({ query });
        return result.items;
      }),
    // utils.members.searchForMention is stable between renders
    [utils.members.searchForMention],
  );
}
